"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListNode = void 0;
const DataModel_1 = require("../model/DataModel");
const Node_1 = require("./Node");
const ListNode = (children, config) => {
    var _a, _b;
    const min = (_a = config === null || config === void 0 ? void 0 : config.minLength) !== null && _a !== void 0 ? _a : 0;
    const max = (_b = config === null || config === void 0 ? void 0 : config.maxLength) !== null && _b !== void 0 ? _b : Infinity;
    const between = (config === null || config === void 0 ? void 0 : config.minLength) && (config === null || config === void 0 ? void 0 : config.maxLength);
    return ({
        ...Node_1.Base,
        type: () => 'list',
        default: () => (config === null || config === void 0 ? void 0 : config.minLength) ? [...Array(min)].map(_ => children.default()) : [],
        navigate(path, index) {
            const nextIndex = index + 1;
            const pathElements = path.getArray();
            if (pathElements.length <= nextIndex) {
                return this;
            }
            return children.navigate(path, nextIndex);
        },
        pathPush(path, index) {
            return path.push(parseInt(index.toString())).contextPush('entry');
        },
        validate(path, value, errors, options) {
            if (options.loose && !Array.isArray(value)) {
                value = options.wrapLists ? DataModel_1.DataModel.wrapLists(this.default()) : this.default();
            }
            if (!Array.isArray(value)) {
                errors.add(path, 'error.expected_list');
                return value;
            }
            else if (between && (value.length < min || value.length > max)) {
                if (min === max) {
                    errors.add(path, 'error.invalid_list_range.exact', value.length, min);
                }
                else {
                    errors.add(path, 'error.invalid_list_range.between', value.length, min, max);
                }
            }
            else if (value.length < min) {
                errors.add(path, 'error.invalid_list_range.smaller', value.length, min);
            }
            else if (value.length > max) {
                errors.add(path, 'error.invalid_list_range.larger', value.length, max);
            }
            const res = value.map((obj, index) => {
                const newObj = children.validate(path.push(index), options.wrapLists ? obj.node : obj, errors, options);
                return options.wrapLists ? { node: newObj, id: obj.id } : newObj;
            });
            for (const a of Object.getOwnPropertySymbols(value)) {
                res[a] = value[a];
            }
            return res;
        },
        hook(hook, path, ...args) {
            var _a;
            return ((_a = hook.list) !== null && _a !== void 0 ? _a : hook.base).call(hook, { node: this, children, config: config !== null && config !== void 0 ? config : {} }, path, ...args);
        }
    });
};
exports.ListNode = ListNode;
